import { Button, Icon, VerticalDivider } from '@smartgift/frontend-toolkit';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useSendRemindersNotification } from '@hero/hooks';
import { useSendRemindersRecognition } from '@hero/services';

import * as S from './style';

const TableHeaderButton = ({ recognitionCode, orderId, link }) => {
  const { t } = useTranslation();

  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (copied) setCopied(false);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [copied]);

  const { send } = useSendRemindersNotification({
    useSendReminder: useSendRemindersRecognition
  });

  const onCopyLinkClick = () => {
    navigator.clipboard.writeText(link?.shortened);
    setCopied(true);
  };

  const handleSendReminder = () => {
    send(recognitionCode, [orderId]);
  };

  return (
    <S.TableHeaderButtonWrapper>
      <Button variant="link" onClick={handleSendReminder}>
        <Icon name="email" color="var(--color-accent-primary-default)" />
        {t('remindRecipient')}
      </Button>
      <VerticalDivider $height="24px" $margin="0 0 0 16px" />
      <Button
        variant="link"
        onClick={onCopyLinkClick}
        style={{
          appearance: 'none',
          padding: 8,
          border: 0,
          outline: 0,
          cursor: 'pointer'
        }}
      >
        {!copied && (
          <Icon
            name="copy-paste"
            color="var(--color-accent-primary-default)"
            style={{
              strokeDasharray: 50,
              strokeDashoffset: copied ? -50 : 0,
              transition: 'all 300ms ease-in-out'
            }}
          />
        )}
        {copied && (
          <Icon
            name="success"
            color="var(--color-primary-500)"
            style={{
              strokeDasharray: 50,
              strokeDashoffset: copied ? 0 : -50,
              transition: 'all 300ms ease-in-out'
            }}
          />
        )}
        {copied ? t('copied') : t('copyUniqueGiftLink')}
      </Button>
    </S.TableHeaderButtonWrapper>
  );
};

export { TableHeaderButton };
